import ShareSpaceRecipientRecord from "models/view-models/share-spaces/share-space-recipient-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface ShareSpaceRecipientPathParams {
    guid: string;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "sharespaces/recipientaccess";
const resourceEndpoint = `${baseEndpoint}/:guid`;
const trackAccessEndpoint = `${resourceEndpoint}/accessedOn`;
const repliedOnEndpoint = `${resourceEndpoint}/repliedOn`;
const resourceType = ShareSpaceRecipientRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const RecipientAccessShareSpaceRecipientService = {
    usePatchTrackAccess: ServiceHookFactory.usePatch<
        ShareSpaceRecipientRecord,
        ShareSpaceRecipientPathParams
    >(resourceType, trackAccessEndpoint),

    usePatchTrackReply: ServiceHookFactory.usePatch<
        ShareSpaceRecipientRecord,
        ShareSpaceRecipientPathParams
    >(resourceType, repliedOnEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default RecipientAccessShareSpaceRecipientService;

// #endregion Exports
